import * as React from 'react';
import * as Session from '../../service/Session';
import * as DTO from '../../service/DTOs';
import * as RB from 'react-bootstrap';
import * as TF from '../../service/tradeflow';
import * as Actions from '../../service/Actions';

import { ChatHistory } from './ChatHistory';
import { ImpactorContacts } from './ImpactorContacts'
import { ImpactorChatList } from './ImpactorChatList'

import { ImpactorChat } from './ImpactorChat';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee, faUsers, faInfo, faSort, faSortAlphaDown, faSortAmountDown } from '@fortawesome/free-solid-svg-icons'
import { faCommentAlt } from '@fortawesome/free-regular-svg-icons'



const iconUsers = <FontAwesomeIcon icon={faUsers} size="lg" />
const iconChats = <FontAwesomeIcon icon={faCommentAlt} size="lg" />
const iconSortUsers = <FontAwesomeIcon icon={faSortAlphaDown} size="lg" />
const iconSortBank = <FontAwesomeIcon icon={faSortAmountDown} size="lg" />

//const iconChats = <FontAwesomeIcon icon="spinner" size="lg" />
 

type ImpactorNavigationProps = {
    syshdr: DTO.SystemHeader;
    user: Session.UserState,
    xsrfToken?: string,
    personalState?: Session.PersonalState,
    //idchat?: number,
    shareChatId?: number,
    appId: number,
    new_messages: DTO.AgentTextMessage[]
};

type ImpactorNavigationState = {
    navigationMode: string;
    sortOrder: 'username' | 'legalname';
};

export class ImpactorNavigation extends React.Component<ImpactorNavigationProps, ImpactorNavigationState> {

    constructor(props: ImpactorNavigationProps) {
        super(props);

        this.setNavMode = this.setNavMode.bind(this);
        this.setSortMode = this.setSortMode.bind(this);

        this.state = {
            ...{ navigationMode: 'chats', sortOrder: 'username' }
        };
    }

    componentDidMount() {
        //TF.CommandProcessBinding(this, { type: 'COMMAND.SelectChat', delegate: this.processSelectChat });
    }

    setNavMode(event: any, mode: string) {
        this.setState({ navigationMode: mode });

        return event.preventDefault();
    }

    setSortMode(event: any, mode: 'username' | 'legalname') {
        this.setState({ sortOrder: mode });

        return event.preventDefault();
    }

    render() {

        let navWidget = undefined;

        if (this.state.navigationMode == 'chats') {
            navWidget = <ImpactorChatList {...this.props} />;
        }
        else if (this.state.navigationMode == 'contacts') {
            navWidget = <ImpactorContacts {...this.props} sortOrder={this.state.sortOrder} />;
        }

        //<i class="fas fa-users"></i>
        //<i class="fas fa-id-card"></i>
        //<RB.Glyphicon glyph="filter" />
        return (
            <div className="otc-panel-impactor-nav">
                <RB.Row>
                    <RB.Col sm={12}>
                <RB.ButtonToolbar >
                            <RB.ButtonGroup bsSize="small">
                                <RB.Button className="otc-impactor-btn-tab" bsStyle={this.state.navigationMode == 'chats' ? 'primary' : 'default'} onClick={e => this.setNavMode(e, 'chats')}>
                                    {iconChats}
                                    <span>{'Чаты'}</span>
                                </RB.Button>
                    </RB.ButtonGroup>
                    <RB.ButtonGroup bsSize="small">
                                <RB.Button className="otc-impactor-btn-tab" bsStyle={this.state.navigationMode == 'contacts' ? 'primary' : 'default'} onClick={e => this.setNavMode(e, 'contacts')}>
                                    {iconUsers}
                                    <span>{'Контакты'}</span>
                                </RB.Button>

                                {this.state.navigationMode == 'contacts'
                                    ? <RB.Button className="otc-impactor-btn-tab" title='Сортировать по имени' bsStyle={this.state.sortOrder == 'username' ? 'success' : 'default'} onClick={e => this.setSortMode(e, 'username')}>{iconSortUsers}<span>{'user'}</span></RB.Button>
                                    : undefined}
                                {this.state.navigationMode == 'contacts'
                                    ? <RB.Button className="otc-impactor-btn-tab" title='Сортировать по юр. лицу' bsStyle={this.state.sortOrder == 'legalname' ? 'success' : 'default'} onClick={e => this.setSortMode(e, 'legalname')}>{iconSortBank}<span>{'bank'}</span></RB.Button>
                                    : undefined}
                    </RB.ButtonGroup>
                </RB.ButtonToolbar>
                    </RB.Col>
                </RB.Row>

                <RB.Row>
                    <RB.Col sm={12}>
                        {navWidget}
                    </RB.Col>
                </RB.Row>

            </div>
        );
    }

}

